// ============================================
// api.ts — API Configuration
// ============================================
// All API calls go through this file.
// Change the base URL here to switch between
// development and production environments.
// ============================================

import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Automatically attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('velumio_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle token expiry globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('velumio_token')
      localStorage.removeItem('velumio_user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api 